import { isPromise } from '../../utils/utils.js';
import __vue_component__ from '../ContentLoader/ContentLoader.vue.js';
import { Promised } from '../../node_modules/vue-promised/dist/vue-promised.es.js';

//
var script = {
  name: 'PromisedContentLoader',
  components: {
    Promised,
    ContentLoader: __vue_component__
  },
  props: {
    value: {
      type: Promise,
      required: true
    },
    width: {
      type: [Number, String],
      default: '200px'
    },
    height: {
      type: [Number, String],
      default: '16px'
    },
    tag: {
      type: String,
      default: 'span'
    },
    pendingDelay: {
      type: Number,
      default: 200
    },
    preserveAspectRatio: {
      type: String,
      default: 'none'
    },
    viewBox: {
      type: String,
      default: undefined
    }
  },
  methods: {
    isPromise(payload) {
      return isPromise(payload);
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/common/PromisedContentLoader.vue_rollup-plugin-vue=script.js